export default [
  {
    path: '/',
    name: 'home',
    component: () => import('@views/home'),
    meta: {
      title: '首页',
    },
  },
  {
    path: '/rank',
    name: 'rank',
    component: () => import('@views/rank/dyd'),
    meta: {
      title: '成绩展示',
    },
  },
  {
    path: '/rank1',
    name: 'rank1920',
    component: () => import('@views/rank/dyd1920'),
    meta: {
      title: '成绩展示',
    },
  },
  {
    path: '/province/tice',
    name: 'tice',
    component: () => import('@views/province/tice'),
    meta: {
      title: '首页',
    },
  },
  {
    path: '/province/yundong',
    name: 'yundong',
    component: () => import('@views/province/yundong'),
    meta: {
      title: '首页',
    },
  },
	{
	  path: '/province/yundong2',
	  name: 'yundong',
	  component: () => import('@views/province/yundong2/index2'),
	  meta: {
	    title: '首页',
	  },
	},
  {
    path: '/login',
    name: 'login',
    component: () => import('@views/login'),
    meta: {
      title: '登录',
    },
  },
]
